/* eslint semi:0 */
import React from 'react'
import { connect } from 'react-redux'
import reduxMount from '../../jsCore/utils/reduxMounter'
import { getIsNativeApp, path } from '../../jsCore/utils/ua'
import { socialBarActions } from './socialBarActions'
import { socialBarReducer } from './socialBarReducer'
import { getIsHybrid } from '../../jsCore/application/pageDataObject'
import { t } from '../../jsCore/providers/i18nProvider/i18nProvider'
import SocialBarComponent from './components/socialBarComponent'
import { MOUNT_POINTS } from '../../jsCore/config/preRenderedSelectorsConfig'
import { isSupportedForDomain, getPageDomain } from '../../jsCore/application/pageDataObject'

const REACTIONS_FEATURE_ID = 'Reactions'
const { isEmbedded } = path
const COMPONENT_NAME = 'SocialBarContainer'
const STATE_KEY = 'socialBar'
const bottomComponentWhitelistByDomain = ['ei']

function mapStateToProps(state) {
  const {
    reactions,
    selectedReaction,
    reactionsComponentState,
    postId,
    votes,
    percentages,
    isInCoverViewport,
  } = state[STATE_KEY]
  return {
    reactions,
    selectedReaction,
    reactionsComponentState,
    postId,
    percentages,
    votes,
    isInCoverViewport,
  }
}

const SocialBarContainer = {
  name: COMPONENT_NAME,
  stateKey: STATE_KEY,
  component: connect(mapStateToProps, socialBarActions)(SocialBarComponent),
  reducer: socialBarReducer,
}

function getSocialBarContainer(componentPosition, initialPosition = { isVisible: false }, title) {
  return {
    ...SocialBarContainer,
    props: {
      title,
      componentPosition,
      reactionsComponentInitialState: {
        [componentPosition]: initialPosition,
      },
    },
  }
}

function shouldLoadReactionsBottomComponent(getSocialBarContainerCb) {
  return bottomComponentWhitelistByDomain.includes(getPageDomain())
    ? getSocialBarContainerCb('bottom', { isVisible: true }, t('reactions.your_reaction'))
    : getSocialBarContainerCb('bottom', { isVisible: false }, t('reactions.your_reaction'))
}

function mountSocialBarComponents() {
  const {
    SOCIAL_BAR_COMPONENT__HEADER,
    SOCIAL_BAR_COMPONENT__COVER,
    SOCIAL_BAR_COMPONENT__DETAILS,
    SOCIAL_BAR_COMPONENT__BOTTOM,
  } = MOUNT_POINTS
  return reduxMount({
    [SOCIAL_BAR_COMPONENT__HEADER]: getSocialBarContainer('header'),
    [SOCIAL_BAR_COMPONENT__COVER]: getSocialBarContainer('cover'),
    [SOCIAL_BAR_COMPONENT__DETAILS]: getSocialBarContainer('details', { isVisible: true }),
    [SOCIAL_BAR_COMPONENT__BOTTOM]: shouldLoadReactionsBottomComponent(getSocialBarContainer),
  })
}

function shouldMountSocialBarComponents() {
  return (
    isSupportedForDomain(REACTIONS_FEATURE_ID) && !getIsHybrid() && !isEmbedded && !getIsNativeApp()
  )
}

export default function initSocialBarComponents() {
  const shouldMountSocialBars = shouldMountSocialBarComponents()
  if (shouldMountSocialBars) {
    mountSocialBarComponents()
  }
  return shouldMountSocialBars
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/reactions/socialBarContainer.js